import { Button, Col, DatePicker, Input, Row, Select } from 'antd'
import moment from 'moment'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { labelForAction } from '../../constants'

const { RangePicker } = DatePicker
const { Option } = Select

const ENTITY_TYPES = [
  'assessment',
  'student_list',
  'subscription',
  'user',
  'job_role',
  'mandate',
  'drive',
  'offer',
  'institute',
  'campus',
  'event',
  'audit_log',
]

/**
 * Filter bar for the audit log.
 *
 * Filters are applied on submit rather than on every keystroke: each change
 * restarts cursor paging from the top, so applying on change would throw away
 * loaded pages while the user is still typing.
 */
const AuditFilter = ({ actions, isLoading, onApply, onReset }) => {
  const [range, setRange] = useState(null)
  const [action, setAction] = useState(undefined)
  const [entityType, setEntityType] = useState(undefined)
  const [actorId, setActorId] = useState('')

  const handleApply = () => {
    onApply({
      from: range?.[0] ? moment(range[0]).startOf('day').toISOString() : undefined,
      to: range?.[1] ? moment(range[1]).endOf('day').toISOString() : undefined,
      action,
      entityType,
      actorId: actorId.trim() || undefined,
    })
  }

  const handleReset = () => {
    setRange(null)
    setAction(undefined)
    setEntityType(undefined)
    setActorId('')
    onReset()
  }

  return (
    <Row gutter={[12, 12]} align="bottom" style={{ marginBottom: 16 }}>
      <Col xs={24} sm={12} md={7}>
        <label htmlFor="audit-range">When</label>
        <RangePicker
          id="audit-range"
          value={range}
          onChange={setRange}
          style={{ width: '100%' }}
          allowClear
        />
      </Col>
      <Col xs={24} sm={12} md={5}>
        <label htmlFor="audit-action">Action</label>
        <Select
          id="audit-action"
          value={action}
          onChange={setAction}
          placeholder="All actions"
          style={{ width: '100%' }}
          allowClear
          showSearch
          optionFilterProp="children"
        >
          {actions.map((item) => (
            <Option key={item} value={item}>
              {labelForAction(item)}
            </Option>
          ))}
        </Select>
      </Col>
      <Col xs={24} sm={12} md={4}>
        <label htmlFor="audit-entity">Entity</label>
        <Select
          id="audit-entity"
          value={entityType}
          onChange={setEntityType}
          placeholder="All entities"
          style={{ width: '100%' }}
          allowClear
        >
          {ENTITY_TYPES.map((item) => (
            <Option key={item} value={item}>
              {item.replace(/_/g, ' ')}
            </Option>
          ))}
        </Select>
      </Col>
      <Col xs={24} sm={12} md={4}>
        <label htmlFor="audit-actor">Actor id</label>
        <Input
          id="audit-actor"
          value={actorId}
          onChange={(event) => setActorId(event.target.value)}
          placeholder="User id"
          onPressEnter={handleApply}
          allowClear
        />
      </Col>
      <Col xs={24}>
        <Button type="primary" onClick={handleApply} loading={isLoading}>
          Apply
        </Button>
        <Button onClick={handleReset} style={{ marginLeft: 8 }}>
          Reset
        </Button>
      </Col>
    </Row>
  )
}

AuditFilter.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.string),
  isLoading: PropTypes.bool,
  onApply: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
}

AuditFilter.defaultProps = {
  actions: [],
  isLoading: false,
}

export default AuditFilter
